import React from 'react';

import { useCurrencyFormat } from './hooks/useCurrencyFormat';
import { useNumberFormat } from './hooks/useNumberFormat';
import { usePercentFormat } from './hooks/usePercentFormat';
import { ICurrency, IDecimal, IPercent } from './interfaces';

const Wrapper = ({ children }: any) => {
  return <span style={{ whiteSpace: 'nowrap' }}>{children}</span>;
};

export const NumberRangeFormatter = ({ formattedValue = [], empty = '-' }) => {
  if (formattedValue[0] === formattedValue[1]) {
    return <Wrapper>{formattedValue[0]}</Wrapper>;
  }

  if (formattedValue[0] === empty) {
    return (
      <React.Fragment>
        <Wrapper>max&nbsp;</Wrapper>
        <Wrapper>{formattedValue[1]}</Wrapper>
      </React.Fragment>
    );
  }
  if (formattedValue[1] === empty) {
    return (
      <React.Fragment>
        <Wrapper>min&nbsp;</Wrapper>
        <Wrapper>{formattedValue[0]}</Wrapper>
      </React.Fragment>
    );
  }

  return (
    <span style={{ display: 'inline-block' }}>
      <span style={{ display: 'flex', flexWrap: 'wrap' }}>
        <Wrapper>{formattedValue[0]}</Wrapper>
        {formattedValue[1] && (
          <Wrapper>&nbsp;-&nbsp;{formattedValue[1]}</Wrapper>
        )}
      </span>
    </span>
  );
};
const Currency = ({
  currency,
  maximumFractionDigits,
  value,
  empty,
}: ICurrency) => {
  const format = useCurrencyFormat({ currency, empty, maximumFractionDigits });
  const formattedValue = format(value);
  return <NumberRangeFormatter formattedValue={formattedValue} empty={empty} />;
};
Currency.displayName = 'NumberRangeFormatter.Currency';

const Percent = ({ maximumFractionDigits, empty, value }: IPercent) => {
  const format = usePercentFormat({ maximumFractionDigits, empty });
  const formattedValue = format(value);
  return <NumberRangeFormatter formattedValue={formattedValue} empty={empty} />;
};
Percent.displayName = 'NumberRangeFormatter.Percent';

const Decimal = ({ maximumFractionDigits, empty, value }: IDecimal) => {
  const format = useNumberFormat({ maximumFractionDigits, empty });
  const formattedValue = format(value);
  return <NumberRangeFormatter formattedValue={formattedValue} empty={empty} />;
};
Decimal.displayName = 'NumberRangeFormatter.Decimal';

export { Currency, Percent, Decimal };
